(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_menu_model"] && !Shopify.designMode) return;
  try {
    function lxFill(){document.querySelectorAll('[data-lx-target]').forEach(function(t){var k=t.getAttribute('data-lx-target');t.innerHTML='';document.querySelectorAll('[data-lx-model] [data-lx-'+k+']').forEach(function(s){t.insertAdjacentHTML('beforeend',s.innerHTML);});});}document.addEventListener('DOMContentLoaded',lxFill);document.addEventListener('shopify:section:load',lxFill);
  } catch(e) { console.error(e); }
})();

})();
